// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons

function ProjectCard({ project }) {
  const maxTextLength = 100;

  return (
    <div className="sm:w-[360px] p-5 rounded-lg shadow-md flex flex-col items-center justify-between border select-none local-theme-bg-md local-theme-border-md">
      <h3 className="local-theme-text-md text-[20px] font-semibold text-center">
        {project.title}
      </h3>

      <p className="mt-2 local-theme-text-xs text-[14px] text-center">
        {project.description.length >= maxTextLength
          ? project.description.substring(0, 100) + "..."
          : project.description}
      </p>

      {project.links?.length > 0 && (
        <div className="mt-4 flex justify-center">
          <a
            href={project.links[0].link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 text-[14px] hover:underline"
          >
            {project.links[0].text}
          </a>
        </div>
      )}
    </div>
  );
}

export default ProjectCard;
